import { styled } from '@/stitches.config';
import { Box } from '@base-app';

export const StyledDateFilter = styled(Box, {
  alignItems: 'baseline',
  display: 'flex',
  justifyContent: 'space-between',
});

export const StyledDateFilterInfo = styled(Box, { display: 'inline-flex', alignItems: 'center' });

export const StyledSelectedRangeText = styled(Box, {
  color: '$darkBlue200',
  display: 'flex',
  fontSize: '$4',
  fontWeight: '$regular',
  lineHeight: '$6',
  paddingRight: '$4',
});

export const StyledDateRange = styled(Box, {
  marginLeft: '$2',
  fontWeight: '$bold',
  lineHeight: '$6',
});
